import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  row: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#f2f2f2'
  },
  headCheck: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    boxShadow: 'inset 1px 1px 0 #BFBFBF, inset 0 -1px 0 #BFBFBF',
    height: 44,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#263057',
    width: '3rem',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#f2f2f2'
  },
  headName: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    boxShadow: 'inset 0px 1px 0 #BFBFBF, inset 0 -1px 0 #BFBFBF',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#f2f2f2'
  },
  headAbsolutePath: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    boxShadow: 'inset 0px 1px 0 #BFBFBF, inset 0 -1px 0 #BFBFBF',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#f2f2f2',
    '@media all and (max-width: 1000px)': {
      display: 'none'
    }
  },
  headPurgeDate: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    boxShadow: 'inset 0px 1px 0 #BFBFBF, inset 0 -1px 0 #BFBFBF',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#f2f2f2',
    '@media all and (max-width: 1200px)': {
      display: 'none'
    }
  },
  headPurgeActionUser: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    boxShadow: 'inset 0px 1px 0 #BFBFBF, inset 0 -1px 0 #BFBFBF',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#f2f2f2',
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },
  headKebab: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    boxShadow: 'inset -1px 1px 0px #BFBFBF, inset 0px -1px 1px #BFBFBF',
    height: 44,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    width: '2rem',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#f2f2f2'
  }
}))

export default useStyles
